// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"42f4ed23","366":"f3b784da","674":"fd86c64b","855":"b85d9f7b","888":"35c08308"}[chunkId] + ".chunk.js";
};